<template>
   <div class="new-hand-box">
     <div class="questions-box">
     <!-- 新手指南 -->
     <div class="titleStyle">
      <span class="changjianwent">常见问题</span>
     </div>
      <div class="headline-box">
        <div class="headline-child"><span>•</span>定位查询</div>
        <div class="headline-child"><sapn>•</sapn>电子围栏</div>
        <div class="headline-child"><sapn>•</sapn>轨迹跟踪</div>
      </div>
        <div class="location-box">
          <h1 class="location-child">定位查询</h1>
          <span>
            选择查看位置，图中标识位置代表最新的定位位置. 点击可以查看：姓名、日期、时间、经纬度、地址（如图示）
          </span>
         <div style="height: 506px;"> 
          <img src="./help/dengweichaxun.jpg" alt="" style="width: 90%; height: 506px; margin-right: 50%; margin-top: 10px;">
         </div>
        </div>
        <div class="weilan-box"> 
        <h1 class="weilan-child">电子围栏</h1>
        <span>选择终端设置→围栏设置→添加围栏。您可在图中随意拖动红色气球中心点，并选择半径区域设置报警区域。操作流程如下图所示:（设置成功后，离开或进入报警区域会收到报警短信提示）</span>
        <div>
          <img src="./help/one.jpg" alt="">
          <img src="./help/tow.jpg" alt="">
          <img src="./help/three.jpg" alt="">
        </div>
      </div>
      <div class="track-box">
          <h1 class="track-child">轨迹跟踪</h1>
          <span >选择查看足迹，查看历史轨迹，前提是某一日期有轨迹跟踪，再选择要回放的日期，点击查看即可显示当天的轨迹。如下图所示（注：勾选右上角的隐藏基站定位点，即只显示GPS轨迹）</span>
          <div style="margin-top: 10px;">
            <img src="./help/four.jpg" alt="">
          </div>
      </div>

     </div> 
   </div>
</template>
<script>
export default {
   name: '',
   components: {
     
   },
   mixins: [],
   props: {
     
   },
   data() {
     return {
       
     }
   },
   computed: {
     
   },
   watch: {
     
   },
   mounted() {
     
   },
   methods: {
     
   }
};
</script>
<style lang='scss' scoped>
  .new-hand-box{
    // height: 100%;
    // width: 100%;
    background-color: #fff;
    // padding: 5%;
    padding-top: 30px;
    padding-bottom: 30px;
    .questions-box{
      border: 1px solid #ccc;
      height:2900px;
      width: 60%;
      margin: 0 auto;
      border-radius: 15px;

      .titleStyle{
        height: 70px;
        line-height: 70px;
        background-color: #EDF6FF;
        border-radius: 15px;
        border-bottom: 1px solid #ccc;
        font-size: 18px;
        padding-left: 50px;
        
        .changjianwent{
          
        }

      }
      .headline-box{
        margin-top: 30px;
        margin-left: 50px;
        height: 100px;
        .headline-child{
          margin-bottom: 10px;
        }
      }
      .location-box{
        margin-top: 30px;
        margin-left: 50px;
        height: 600px;
        .location-child{
          font-size: 16px;
          font-weight: 700;
          margin-bottom: 10px;
        }
      }
      .weilan-box{
        margin-top: 30px;
        margin-left: 50px;
        height: 1350px;
        .weilan-child{
        font-size: 17px;
        font-weight: 700;
        margin-bottom: 10px;

        }
      }
      .track-box{
        margin-left: 50px;
        margin-bottom: 30px;
        .track-child{
          font-size: 17px;
          font-weight: 700;
          margin-bottom: 10px;

        }

      }
    }
  }
</style>